import { z } from 'zod';
import { initContract } from '@ts-rest/core';
import { DurationLikeObject, ObjectIdSchema, ValidDateTime } from '@repo/common/schemas';
import { ping } from './shared.js';
const c = initContract();

export const unsafeDebugContract = c.router(
  {
    compareNoteMethods: {
      method: 'POST',
      path: '/compareNoteMethods',
      body: z.object({
        candidateId: ObjectIdSchema,
        lookupStart: DurationLikeObject.or(ValidDateTime).default({ days: 30 }),
        clearExistingNotes: z.boolean().default(true),
      }),
      responses: {
        200: z.looseObject({
          result: z.record(z.string(), z.unknown()),
        }),
      },
    },
    ping,
  },
  {
    pathPrefix: '/unsafeDebug',
    baseHeaders: {
      Authorization: z.string().optional(),
    },
  }
);
